<template>

  <div class="Rebate">
    <b-overlay :show="show" spinner-variant="primary" spinner-large rounded="sm" style="height:100vh" variant="dark"
      id="loader">
      <b-row>
        <b-col cols="12 headerF">
          <HeaderFixed />
        </b-col>
        <b-col cols="12 headerM">
          <HeaderMobile />
        </b-col>
      </b-row>
      <b-container id="consBillDiv" fluid style="padding-top: 100px;text-align:left">

        <b-row>
          <b-col cols="12">
            <b-breadcrumb style=" background-color: #e9ecef78;">
              <b-breadcrumb-item href="#home">
                <router-link to="/">
                  <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                  Home
                </router-link>
              </b-breadcrumb-item>

              <b-breadcrumb-item href="#" active>Vendor List</b-breadcrumb-item>
            </b-breadcrumb>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <span class="title"> Vendor List</span>
          </b-col>
        </b-row>
        <hr />
        <div class="paddingLeft30px">
          <br>
          <!-- <p style="color:red;">
          We are facing some technical issues with our payment gateway. This is expected to be resolved soon. Sorry for the inconvenience.
        </p> -->
          <b-row>
            <b-col col cols="12" sm="12" md="12" lg="2" style="padding-top: 7px;">
              <span style="font-weight:600">Select Material<span class="text-danger">*</span></span>
            </b-col>
            <b-col col cols="8" sm="8" md="8" lg="3">
              <select id="selectMaterial" required style="height:2rem;width:100%" @change="changeMaterial()">
                <option selected value="0">---Select---</option>
              </select>
            </b-col>
            <b-col col cols="12" sm="12" md="12" lg="2" style="padding-top: 7px;">
              <span style="font-weight:600">Select Material List <span class="text-danger">*</span></span>
            </b-col>
            <b-col col cols="8" sm="8" md="8" lg="3">
              <select id="selectEquipment" style="height:2rem;width:100%" @change="changeEquipment()">
                <option selected value="0">---Select---</option>
              </select>
            </b-col>
          </b-row>

          <br>
          <div id="VendorListDiv" class="hideDetails" style="font-size:0.8rem">
            <span class="heading"> Vendor List</span>
            <br><br>
            <b-table bordered responsive :items="vendor" :fields="vendorFields" style="width:90vw">
              <template v-slot:cell(remark)="data">
                <span v-html="data.value"></span>
              </template>
            </b-table>

          </div>
          <br>

        </div>
      </b-container>

      <br><br>
    </b-overlay>

    <b-modal id="model" centered scrollable title="ALERT !" :static="true" hide-footer>
      <span class="data" id="msg"> </span>
      <br><br>
      <b-button style="width:8rem" variant="outline-primary" @click="closeModal()">OK</b-button>
    </b-modal>
  </div>
</template>


<script>

import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)
//const urlCommon = "http://localhost:8081/website";
//const urlCommon = "https://www.apdcl.org/website";
var consNo = "";
var sdCode = "";
var thColor = '#0288d1';
var equipmentList = [];
var vendorList = [];
var catCode = "";
export default {
  name: 'PayBill',
  components: {

    'HeaderFixed': HeaderFixed,
    'HeaderMobile': HeaderMobile
    //MarqueeText

  },
  computed: {

  },
  data() {
    return {

      vendorFields: [
        { key: 'slno', label: 'Sl No', thStyle: { width: '10vw', backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'name', label: 'Name', thStyle: { width: '60vw', backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'issue_date', label: 'Issue Date', thStyle: { width: '10vw', backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'validity', label: 'Validity', thStyle: { width: '10vw', backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'remark', label: 'Remark', thStyle: { width: '40vw', backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },

      ],
      vendor: [],
      show: false
    }
  },
  methods: {
    changeMaterial() {
      var materialId = document.getElementById("selectMaterial").value;
      document.getElementById("selectEquipment").innerHTML = "";
      var select = document.getElementById("selectEquipment");

      var link = equipmentList.filter(function (obj) { return obj[2] == materialId; });
      console.log(link);

      var option = document.createElement("option");
      option.text = "--Select--";
      option.value = 0;
      select.appendChild(option);

      link.forEach(function (element, index) {
        option = document.createElement("option");
        option.text = element[1];
        option.value = element[0];
        select.appendChild(option);
      })
    },
    changeEquipment() {

      var equipmentId = document.getElementById("selectEquipment").value;
      //  document.getElementById("").innerHTML ="";
      document.getElementById("VendorListDiv").classList.add("showDetails");
      var link = vendorList.filter(function (obj) { return obj.equipment_id == equipmentId; });
      console.log(link);
      var temp = [];
      var i = 0;
      link.forEach(function (element, index) {
        var remark = "";
        if (element.validity != "NA") {
          var vd = element.validity.split("-");
          var vDate = vd[2] + "-" + vd[1] + "-" + vd[0];
          var currDate = new Date(element.curr_date);
          var validity = new Date(vDate);

          console.log("currDate==" + currDate);
          console.log("validity==" + validity);
          if (currDate.getTime() > validity.getTime()) {
            remark = "<span style='color:red;font-weight:600'>EXPIRED</span>";
          }
          else {

            if (element.remark != "NA") {
              remark = "<span style='color:red;font-weight:600'>" + element.remark + "</span>";
            }
            else {
              remark = "<span style='color:green;font-weight:600'>ACTIVE</span>";
            }
          }
        }


        else {
          remark = element.remark;
        }




        var obj = {
          "slno": ++i,
          "name": element.name,
          "issue_date": element.issue_date,
          "validity": element.validity,
          "remark": remark
        }
        temp.push(obj);
      })
      this.vendor = temp;
    },

    closeModal() {
      this.$bvModal.hide('model')
    },


  },
  mounted() {
    this.show = true;
    var parent = this;
    axios.get(this.$urlCommon + '/api/web/getMaterialList')
      .then((response) => {
        this.show = false;
        //  materialList = response.data;
        console.log(response.data);
        var select = document.getElementById("selectMaterial");

        select.innerHTML = "";

        var defaultOption = document.createElement("option");
        defaultOption.text = "--Select--";
        defaultOption.value = "";
        defaultOption.disabled = true;
        defaultOption.selected = true;
        select.appendChild(defaultOption);

        const sortedMaterials = response.data.material.sort((a, b) => {
          return a[1].localeCompare(b[1]); // A–Z
        });

        sortedMaterials.forEach(function (element, index) {
          var option = document.createElement("option");
          option.text = element[1];
          option.value = element[0];
          select.appendChild(option);
        })

      }),
      this.show = true;
    axios.get(this.$urlCommon + '/api/web/getEquipmentList')
      .then((response) => {
        this.show = false;
        equipmentList = response.data.equipment;
        console.log(response.data);
      })
    this.show = true;
    axios.get(this.$urlCommon + '/api/web/getVendorList')
      .then((response) => {
        this.show = false;
        vendorList = response.data.vendor;
        console.log(response.data);
      })
  }
}
//background-image: url('../assets/bg.jpg');background-color: #82828226;

</script>

<style scoped="true">
.paddingRow {
  padding: 0.7rem;
}

.paddingCol {
  padding: none;
}

.label {
  font-weight: 600;
}

.data {
  font-weight: 600;
  color: #ff5722;
  font-size: 1.5rem;
}

.hideDetails {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s linear;
  /*  box-shadow: 2px 2px 10px 2px #bdbdbd; */
  padding-top: 1rem;
  /* margin-right: 1.5rem; */
}

.showDetails {

  visibility: visible;
  opacity: 1;
}

hr {
  margin-top: 5px;
  margin-bottom: 5px;
}

.go:focus {
  box-shadow: none;
}

.headerF {
  display: block;
}

.headerM {
  display: none;
}

.paddingLeft30px {
  padding-left: 30px;
}

@media (max-width: 768px) {
  .headerF {
    display: none;
  }

  .headerM {
    display: block;
  }

  .paddingLeft30px {
    padding-left: 0px;
  }
}

@media only screen and (max-width: 414px) {
  .paddingCol {
    padding: 0.7rem;
  }

  .paddingRow {
    padding: none !important;
  }

  .paddingLeft30px {
    padding-left: 0px;
  }
}
</style>
